module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAVCAYAAACpF6WWAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH3wIJCCcVkX8fhgAAAENJREFUOMtjXLVq8X8GKgMWBgYGhtDQGKoZuHr1EoihDAwMDIyNjVQxdJWWMgMTAw3AqKGjho4aOmroqKHUAYy0qKMAqfkLE0jjrkUAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/components/images/X.png
// module id = 254
// module chunks = 0